import { t } from 'ttag'
import { useContext } from 'react'

import { PG, NAVIANCEBLUE } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Option, OptionGroup } from '@h2/components/containers/optionGroup'
import { StudentIcon } from '@h2/components/icons/student'
import { ProgramIcon } from '@h2/components/icons/program'
import { K12Icon } from '@h2/components/icons/k12'
import { AdultEducationIcon } from '@h2/components/icons/adultEducation'
import { Card } from '@h2/common/components/card'
import { Globals } from '@h2/globals'

import { props } from './props'
import { ContentWrap, OptionBody } from './components'

import { Explorer } from '../highlights/explorer'
import { Back } from '../back'
import { Controls } from '../controls'

const ExplorerType = ({ inDialog, validate, renderPanel }) => {
  const { isNavianceUser } = useContext(Globals)

  return (
    <Card inDialog={inDialog}>
      <Card.Highlight color={isNavianceUser ? NAVIANCEBLUE : PG}>
        <Explorer />
      </Card.Highlight>
      <Card.Content>
        <ContentWrap>
          <Heading level="2" align="center" mb="12px">
            {isNavianceUser ? t`Select your status` : t`I plan to use the system as a...`}
          </Heading>
          <Text align="center">
            {!isNavianceUser && t`Select the option that best applies to you:`}
          </Text>
          <OptionGroup
            gap="15px"
            onClick={value => {
              validate({
                isStudent: value === 'yes',
                studentType: isNavianceUser ? 'k12' : null
              })
            }}>
            <Option value="yes">
              <OptionBody>
                {isNavianceUser ? <K12Icon size="large" /> : <StudentIcon size="large" />}
                <span className="flex">
                  <span>{t`Student`}</span>
                  <span>
                    {isNavianceUser
                      ? t`I'm in grades 6-12 and want to explore future job opportunities.`
                      : t`I'm still getting my education but am developing plans for what's next.`}
                  </span>
                </span>
              </OptionBody>
            </Option>
            <Option value="no">
              <OptionBody>
                {isNavianceUser ? (
                  <AdultEducationIcon size="large" />
                ) : (
                  <ProgramIcon size="large" />
                )}
                <span className="flex">
                  <span>{t`Job Seeker`}</span>
                  <span>
                    {isNavianceUser
                      ? t`I've graduated from high school and want to explore job opportunities.`
                      : t`I'm already in or ready to join the job market.`}
                  </span>
                </span>
              </OptionBody>
            </Option>
          </OptionGroup>
          <Controls>
            <Back onClick={() => renderPanel('basic')} />
          </Controls>
        </ContentWrap>
      </Card.Content>
      <Card.Detour>
        <Back onClick={() => renderPanel('basic')} />
      </Card.Detour>
    </Card>
  )
}

ExplorerType.propTypes = { ...props }

export { ExplorerType }
